import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import '../styles/DomainDnsPanel.css';

function truncateName(name, domainName) {
  if (!name) return '@';
  // Show @ for apex
  if (name === domainName || name === domainName + '.') return '@';
  // Strip domain suffix for readability
  const suffix = '.' + domainName;
  if (name.endsWith(suffix)) return name.slice(0, -suffix.length);
  return name;
}

function truncateContent(content, maxLen = 32) {
  if (!content) return '—';
  if (content.length <= maxLen) return content;
  return content.slice(0, maxLen) + '…';
}

export default function DomainDnsPanel({ domainId, domainName, onClose, onModeChange }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!domainId) return;
    setLoading(true);
    setError(null);

    api.get(`/api/customer/domains/${domainId}/dns`)
      .then((data) => {
        setRecords(data.records || []);
        if (data.error) setError(data.error);
      })
      .catch((err) => {
        console.error('DNS fetch failed:', err);
        setError('DNS records unavailable');
      })
      .finally(() => setLoading(false));
  }, [domainId]);

  return (
    <div className="dns-panel">
      <div className="dns-panel-header">
        <h3 className="dns-panel-title">DNS Records</h3>
        {onClose && (
          <button className="dns-panel-close" onClick={onClose}>×</button>
        )}
      </div>

      <div className="dns-panel-content">
        {loading ? (
          <div className="dns-panel-empty">Loading DNS records...</div>
        ) : error ? (
          <div className="dns-panel-empty">{error}</div>
        ) : records.length === 0 ? (
          <div className="dns-panel-empty">No DNS records found</div>
        ) : (
          <div className="dns-table-wrap">
            <table className="dns-table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Name</th>
                  <th>Content</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {records.map((rec, i) => (
                  <tr key={i}>
                    <td className="dns-type">{rec.type}</td>
                    <td className="dns-name" title={rec.name}>
                      {truncateName(rec.name, domainName)}
                    </td>
                    <td className="dns-content" title={rec.content}>
                      {truncateContent(rec.content)}
                    </td>
                    <td className="dns-proxied">
                      {rec.proxied ? (
                        <span className="dns-proxy-on" title="Proxied through Cloudflare">☁️</span>
                      ) : (
                        <span className="dns-proxy-off" title="DNS only">☁️</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="dns-panel-actions">
        <button
          className="dns-action-btn"
          onClick={onModeChange}
        >
          Return to Conversations →
        </button>
      </div>
    </div>
  );
}
